module.exports = __webpack_public_path__ + "static/media/2.39d5897f.jpg";